import { getTypedState } from 'ducks/hooks'
import { InvoiceType } from './types'

export const getInvoice = () => (): InvoiceType | null => {
  const { invoice } = getTypedState()
  return invoice ?? null
}
